import { useAppContext } from '../utils/context/app-context'

// Create a userIsReadyOnly hook that checkes if the logged in user only has read_only access from state
export function useUserIsReadOnly() {
	const { state } = useAppContext();
	// Ensure that string "0" does not evaluate to truthy
	return state.logged_in && (state?.user?.read_only === 1 || state?.user?.read_only === "1" || state?.user?.read_only === true);
}